import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../select";

interface DatasetRowSelectProps {
  row?: number;
  totalRows: number;
  onSelectRow: (row: number) => void;
}

const DatasetRowSelect = ({
  row,
  totalRows,
  onSelectRow,
}: DatasetRowSelectProps) => {
  return (
    <Select
      value={row?.toString()}
      onValueChange={(value) => {
        onSelectRow(Number(value));
      }}
    >
      <SelectTrigger>
        <SelectValue placeholder="Select a row number" />
      </SelectTrigger>
      <SelectContent className="max-h-[300px] overflow-y-auto">
        {Array.from({ length: totalRows }, (_, index) => (
          <SelectItem key={index} value={(index + 1).toString()}>
            {index + 1}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default DatasetRowSelect;
